import { UserEnum } from "../types/userEnum";
import BaseEntityService from "./baseEntityService";

const serviceUrlSuffix = "v1/user-enums";

class UserEnumService extends BaseEntityService<UserEnum> {
  constructor() {
    super(serviceUrlSuffix);
  }

  async fetchSubExistenceMap(name: string): Promise<Record<string, boolean>> {
    const response = await this.httpClient.get<Record<string, boolean>>(
      `${this.serviceUrlSuffix}/sub-existence-map/${name}`
    );
    return response.data;
  }
}

export const userEnumService = new UserEnumService();
